<template>
  <div class="career">
    <div class="profile-field__title">Карьера</div>

    <div v-if="field.career.medicalBook" class="medical-book">
      <c-switcher v-model="hasMedicalBook" label="Есть медицинская книжка" />
    </div>

    <div
      class="row align-items-end"
      :class="{
        'salary-error': error && error.salary,
        'work-start-error': error && error.startDate,
      }"
    >
      <div v-if="field.career.salaryShow" class="col col-12 col-md-2 salary">
        <div
          class="field"
          :class="{
            'is-invalid': error && error.salary,
          }"
        >
          <c-input
            v-model="salary"
            label="Желаемая зарплата, ฿"
            :clearable="true"
            placeholder="0"
            type="price-number"
            :split="true"
            :fractional-length="0"
            :required-mark="field.career.salaryRequired"
            :invalid="error && error.salary"
            :error="error && error.salary"
          />
        </div>
      </div>

      <div v-if="field.career.schedule.show" class="col col-12 col-md-2 schedule">
        <div class="field">
          <c-select
            v-model="schedule"
            type="select"
            label="Желаемый график работы"
            placeholder="Любой"
            :searchable="true"
            :items="options"
            :clearable="true"
            :custom-options="field.career.schedule.custom"
          />
        </div>
      </div>

      <div v-if="field.career.workStartShow" class="col cols-12 col-md-2 work-start">
        <div
          class="field"
          :class="{
            'is-invalid': error && error.startDate,
          }"
        >
          <c-input
            ref="date"
            v-model="startDate"
            type="date"
            placeholder="00.00.0000"
            label="Когда сможете приступить к работе"
            icon="calendar"
            :clearable="true"
            :editable="true"
            :icon-right="true"
            :required-mark="field.career.workStartRequired"
            :required="error && error.startDate"
            :required-message="error && error.startDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CSwitcher from "@/components/controls/switcher";
import CInput from "@/components/controls2/Input";
import CSelect from "@/components/controls2/Select";
import { SYSTEM_TYPES, FIELD_TYPE_CAREER } from "@/domains/profile/constants/system-types";
import { formatList } from "../utils";

const field = SYSTEM_TYPES[FIELD_TYPE_CAREER];

export default {
  components: { CSwitcher, CInput, CSelect },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      hasMedicalBook: false,
      salary: "",
      schedule: null,
      startDate: "",
    };
  },

  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),
    dictionaryCode() {
      return field.dictionaryCodes.schedule;
    },
    variants() {
      return this.dictionaries[this.dictionaryCode] || [];
    },
    options() {
      return formatList(this.variants);
    },
  },

  watch: {
    hasMedicalBook() {
      this.updateValue();
    },
    salary() {
      this.updateValue();
    },
    schedule() {
      this.updateValue();
    },
    startDate() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  async created() {
    await this.$store.dispatch("profile/getDictionary", { code: this.dictionaryCode });
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { hasMedicalBook, salary, schedule, startDate } = value.value || {};

      this.hasMedicalBook = hasMedicalBook === "0" ? false : !!hasMedicalBook;
      this.salary = salary || "";
      this.startDate = startDate || "";

      if (this.$refs.date) {
        this.$refs.date.setDateInputTypeDate(this.startDate);
      }

      if (schedule) {
        const { id, text, custom } = schedule;

        if (!this.schedule || this.schedule.value !== id) {
          this.schedule = {
            value: `${id}`,
            label: `${text}`,
            custom,
          };
        }
      } else {
        this.schedule = null;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      let scheduleValue = null;
      if (this.schedule) {
        const { value, label, custom } = this.schedule;
        scheduleValue = {
          id: value,
          text: label,
          custom,
        };
      }
      const newValue = {
        hasMedicalBook: this.hasMedicalBook ? 1 : 0,
        salary: this.salary,
        startDate: this.startDate,
        schedule: scheduleValue,
      };

      this.$emit("input", {
        value: newValue,
      });

      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
@import "~@/assets/styles/grid";

.salary,
.schedule,
.work-start {
  padding-top: 6px;
}
.salary,
.schedule {
  margin-bottom: 25px;
}
.row {
  margin-top: 25px;
}
.work-start {
  /deep/ {
    .c-input-label {
      white-space: nowrap;
    }
  }
}

.career {
  /deep/ {
    .c-input-required {
      position: absolute;
      margin-top: 0;
    }
  }
}

.work-start-error {
  .work-start {
    padding-bottom: 24px;
  }
}

.salary-error {
  .salary {
    padding-bottom: 24px;
  }
}

@include bootstrapMd {
  .career {
    @include gridGenerator(10);
  }
  .salary,
  .schedule {
    margin-bottom: 0;
  }

  .salary-error,
  .work-start-error {
    .salary, .work-start, .schedule {
      padding-bottom: 24px;
    }
  }
}

@include bootstrapXl {
  .career {
    @include gridGenerator(12);
  }
}
</style>
